export const getStartEndOffsets = (label: string, second: number) => {
  if (label === 'Other: (Text Prompt)') {
    return { startOffset: second };
  } else {
    const startOffset = Math.max(0, second - 8);
    const endOffset = second + 7;
    return { startOffset, endOffset };
  }
};
